// Framework and third-party non-ui
import React, { Component } from "react";

// Redux operations and local helpers/utils/modules
import Button from "../../../common/components/Button";
import Context from "../../../context/Context";
import { ModalController } from "../../../common/components/Modal";
import OfficePlan from "../../base/OfficePlan";
import Planner from "../../base/Planner";
import * as component from "../../../components/util/component";
import * as portalUtil from "../../../util/portalUtil";
import * as planGroupUtil from "../../base/ReviewerManagement/planGroupUtil";
import {ListItem} from "../../styles/Common/list";

import DeleteIcon from "calcite-ui-icons-react/TrashIcon";

// Component specific modules (Component-styled, etc.)
import {
  ContentWrapper,
  HeaderContainer,
  Header,
  SearchWrapper,
  SubHeaderContainer,
  SortContainer
} from "../../styles/backstageStyles";
import {
  TableContainer,
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td
} from "../../styles/tableStyles";
// App components

import TextField from "../../../common/components/TextField";

// Third-party components (buttons, icons, etc.)
import Select from "calcite-react/Select";
import { MenuItem } from "calcite-react/Menu";
import SortAscendingIcon from "calcite-ui-icons-react/SortAscendingIcon";
import SortDescendingIcon from "calcite-ui-icons-react/SortDescendingIcon";

// JSON

// CSS

export default class OpenPlan extends Component {
  _lastPromise;
  _mounted = false;

  constructor(props) {
    super(props);
    this.state = component.newState({
      resultItems: null,
      searchText: null,
      versionInfos: null,
      sortBy: "title",
      sortDir: "asc",
      nextStart: -1
    });
  }

  componentDidMount() {
    this._mounted = true;
    this.query({});
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
  }

  deletePlan = (event, item) => {
    event.stopPropagation();
    const i18n = Context.instance.i18n;
    const title = item.title;
    const planTitleString = i18n.spaceplanner.backstage.deletePlan.prompt.replace(
      "{planName}",
      title
    );
    const options = {
      title: i18n.spaceplanner.backstage.deletePlan.caption,
      message: planTitleString,
      okLabel: i18n.spaceplanner.backstage.deletePlan.buttonCaption,
      closeOnOK: true,
      closeOnCancel: true
    };
    ModalController.confirm(options).then(result => {
      if (result.ok) {
        const project = Context.instance.spaceplanner.planner.project;
        let parameter = "";
        if (project && project.isVersioned) {
          const project = Context.instance.spaceplanner.planner.project;
          const versionManager = project.versionedInfo.versionManager;
          const versionInfo = item.versionInfo;
          versionManager
            .deleteVersion(versionInfo)
            .then(() => {
              parameter = {
                searchText: this.state.searchText,
                type: "delete"
              };
              this.query(parameter);
            })
            .catch(ex => {
              let submessage = ex.submessage || ex.message;
              let title =
                i18n.spaceplanner.backstage.deletePlan.errorDeletingTitle;
              let message =
                i18n.spaceplanner.backstage.deletePlan.errorDeletingMessage;
              if (ex.message === "The version could not be located") {
                title =
                  i18n.spaceplanner.backstage.deletePlan.errorDeletePlanTitle;
                message = i18n.spaceplanner.backstage.deletePlan.planNotLocated;
                submessage = null;
              }
              ModalController.alert({
                isError: true,
                title: title,
                message: message,
                submessage: submessage
              });
              this.setState({ isWorking: false });
              console.error("Error deleting plan", ex);
            });
        } else {
          // planGroupUtil.findHostedPlanGroupId(item)
          // .then(portalGroupId => {
          //   return planGroupUtil.deletePlanGroup(portalGroupId)
          // }).then(result => {
            // return this.deletePortalItem(item.portalItem)
          // })
          this.deletePortalItem(item.portalItem).then(() => {
              setTimeout(() => {
                this.query({ searchText: this.state.searchText });
              }, 1000);
            })
            .catch(ex => {
              let submessage = ex.submessage || ex.message;
              ModalController.alert({
                isError: true,
                title:
                  i18n.spaceplanner.backstage.deletePlan.errorDeletingTitle,
                message:
                  i18n.spaceplanner.backstage.deletePlan.errorDeletingMessage,
                submessage: submessage
              });
              this.setState({ isWorking: false });
              console.error("Error deleting plan", ex);
            });
        }
      }
    });
  };

  deletePortalItem = item => {
    return portalUtil.deleteItems(item.id,item.owner);
  };

  disableDelete = item => {
    const user = Context.getInstance().user;
    const isAdmin = user.isAdmin();
    const project = Context.instance.spaceplanner.planner.project;
    const userName = user.portalUser.username;
    if (project && project.isVersioned) {
      const openPlanId = Context.instance.spaceplanner.planId;
      if (openPlanId && item && item.versionInfo) {
        if (openPlanId === item.versionInfo.versionGuid) return true;
      }
      if (isAdmin) return false;
      if (item && item.versionInfo) {
        const owner=item.owner;
        if (userName === owner) return false;
      }
      return true;
    } else {
      const openPlanId = Context.instance.spaceplanner.planId;
      if (openPlanId && item && item.id) {
        if (openPlanId === item.id) return true;
      }
      if (isAdmin) return false;
      if (item) {
        const itemOwner = item.owner;
        if (userName === itemOwner) return false;
      }
      return true;
    }
  };

  getInfo(item, isVersion, versionManager) {
    const djLocale = Context.instance.lib.dojo.locale;
    const makeDate = v => {
      const d = new Date(v);
      const s = djLocale.format(d, {
        formatLength: "short"
      });
      return s;
    };

    const info = {
      id: null,
      title: null,
      created: null,
      modified: null,
      summary: null,
      owner: null,
      portalItem: null,
      versionInfo: null
    };

    if (isVersion) {
      info.id = item.versionGuid;
      info.title = versionManager.getVersionTitle(item);
      info.created = item.creationDate;
      info.modified = item.modifiedDate;
      info.createdString = makeDate(item.creationDate);
      info.modifiedString = makeDate(item.modifiedDate);
      info.summary = item.description;
      info.owner = versionManager.getVersionOwner(item);
      info.versionInfo = item;
    } else {
      info.id = item.id;
      info.title = item.title;
      info.created = item.created;
      info.modified = item.modified;
      info.createdString = makeDate(item.created);
      info.modifiedString = makeDate(item.modified);
      info.summary = item.snippet;
      info.owner = item.owner;
      info.portalItem = item;
    }
    return info;
  }

  makeVersionedResultItems(searchText, versionManager, versionInfos) {
    let lc = null;
    if (typeof searchText === "string" && searchText.length > 0) {
      lc = searchText.toLowerCase();
    }
    const resultItems = [];
    if (Array.isArray(versionInfos)) {
      versionInfos.forEach(versionInfo => {
        if (versionInfo.versionId !== 0) {
          let title = versionManager.getVersionTitle(versionInfo);
          let ok = true;
          if (lc) {
            ok = title && title.toLowerCase().includes(lc);
          }
          if (ok) {
            resultItems.push(this.getInfo(versionInfo, true, versionManager));
          }
        }
      });
    }
    resultItems.sort(this.compareValues(this.state.sortBy, this.state.sortDir));
    //return this.state.sortDir === "asc" ? resultItems : resultItems.reverse();
    return resultItems;
  }

  compareValues = (key, order = "asc") => {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      let comparison = 0;

      let varA = a[key];
      let varB = b[key];
      if (typeof a[key] === "string") {
        // varA = a[key].toUpperCase();
        // varB = b[key].toUpperCase();
        varA = a[key];
        varB = b[key];
        comparison = varA.localeCompare(varB);
      } else if (typeof a[key] === "number") {
        varA = a[key];
        varB = b[key];
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
      } else if (a[key] instanceof Date) {
        varA = a[key].getTime();
        varB = b[key].getTime();
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
      } else {
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
      }
      return order === "desc" ? comparison * -1 : comparison;
    };
  };

  onSearchTextChanged = evt => {
    let v = evt.target.value;
    this.setState({ searchText: v });
    this.query({ searchText: v });
  };

  openPlan = (evt, planItem) => {
    evt.stopPropagation();
    let planId, planAppId;
    const planner = Context.instance.spaceplanner.planner;
    if (planItem.versionInfo) {
      planId = planItem.versionInfo.versionGuid;
      planAppId = Planner.getParentAppId(planItem);
    } else {
      const portalItem = planItem.portalItem;
      planId = portalItem.id;
      planAppId = Planner.getParentAppId(portalItem);
    }
    planner.reloadApp(planAppId, planId);
  };

  query(options) {
    const project = Context.instance.spaceplanner.planner.project;
    if (project && project.isVersioned) {
      this.queryVersioned(options);
    } else if (project) {
      this.queryHosted(options);
    }
  }

  queryHosted(options) {

    const portal = Context.instance.getPortal();
    if (!portal) return Promise.resolve();

    const appendQ = (query, q) => {
      if (query.length > 0) query += " AND ";
      query += q;
      return query;
    };

    let props = {
      itemType: "Feature Service",
      start: 1,
      sortField: options.sortBy || this.state.sortBy,
      sortOrder: options.sortDir || this.state.sortDir
    };

    if(this.state.nextStart > 1 && options.isMore){
      props.start=this.state.nextStart;
    }

    let query = props.query || "";
    if (typeof props.itemType === "string" && props.itemType.length > 0) {
      query = appendQ(query, '(type: "' + props.itemType + '")');
    }

    query = appendQ(
      query,
      '(typekeywords: "' + OfficePlan.TypeKeywordFS + '")'
    );

    const considerProject = true;
    const appItem = Context.instance.configuration.appItem;
    if (appItem && considerProject) {
      const subkw = OfficePlan.TypeKeywordParentPfx + appItem.id;
      query = appendQ(query, '(typekeywords: "' + subkw + '")');
    }

    // if (props.orgOnly) {
    //   const user = Context.instance.user;
    //   let orgId = portal.id;
    //   if (user.portalUser) orgId = user.portalUser.orgId;
    //   if (typeof orgId === "string" && orgId.length > 0) {
    //     const qOrg = "((orgid:" + val.escapeForLucene(orgId) + ") -owner:esri_livingatlas)";
    //     query = appendQ(query,qOrg);
    //   }
    // }
    //

    let searchText = this.state.searchText;
    if (options && options.hasOwnProperty("searchText")) {
      searchText = options.searchText;
    }
    if (typeof searchText === "string" && searchText.length > 0) {
      query = appendQ(query, "(" + searchText + ")");
    }

    const queryParams = {
      query: query,
      start: props.start,
      num: 50
    };
    if (props.sortField) {
      queryParams.sortField = props.sortField;
      if (props.sortOrder) queryParams.sortOrder = props.sortOrder;
    }

    let promise = (this._lastPromise = portal.queryItems(queryParams));
    promise
      .then(result => {
        if (!this._mounted) return;
        if (promise !== this._lastPromise) return;

        let nextStart=-1;

        if(result.nextQueryParams){
          nextStart=result.nextQueryParams.start;
        }

        let resultItems = [];
        if (result && result.results) {
          result.results.forEach(item => {
            resultItems.push(this.getInfo(item));
          });

         if (options.isMore) {
            const prevFeatureItems = this.state.resultItems;
            if (prevFeatureItems && prevFeatureItems.length > 0) {
              resultItems = prevFeatureItems.concat(resultItems);
            }
          }
        }
        this.setState({
          isWorking: false,
          resultItems: resultItems,
          nextStart:nextStart
        });
      })
      .catch(ex => {
        console.error("Error querying portal items", ex);
        if (this._mounted && promise === this._lastPromise) {
          this.setState({
            isWorking: false
          });
        }
      });
  }

  queryVersioned(options) {
    const project = Context.instance.spaceplanner.planner.project;
    const versionManager = project.versionedInfo.versionManager;
    const task = {};
    let searchText = this.state.searchText;
    if (options && options.hasOwnProperty("searchText")) {
      searchText = options.searchText;
    }
    task.versionInfos = this.state.versionInfos;
    let hasVersionInfo = Array.isArray(task.versionInfos);

    let promise = (this._lastPromise = Promise.resolve());
    promise
      .then(() => {
        if (!hasVersionInfo || (options && options.type === "delete")) {
          return versionManager.readVersionInfos(task);
        }
      })
      .then(() => {
        if (
          this._mounted &&
          promise === this._lastPromise &&
          task.versionInfos
        ) {
          let resultItems = this.makeVersionedResultItems(
            searchText,
            versionManager,
            task.versionInfos
          );
          let state = {
            isWorking: false,
            resultItems: resultItems
          };
          if (!hasVersionInfo) {
            state.versionInfos = task.versionInfos;
          }
          this.setState(state);
        }
      })
      .catch(ex => {
        console.error("Error querying versions", ex);
        if (this._mounted && promise === this._lastPromise) {
          this.setState({
            isWorking: false
          });
        }
      });
  }

  changeSortBy = sortBy => {
    if (sortBy !== this.state.sortBy) {
      let sortDir = "asc";
      if (sortBy === "created" || sortBy === "modified") {
        sortDir = "desc";
      }
      this.setState({
        sortBy: sortBy,
        sortDir: sortDir
      });
      this.query({
        searchText: this.state.searchText,
        sortBy: sortBy,
        sortDir: sortDir
      });
    }
  };

  changeSortDir = () => {
    const sortDir = this.state.sortDir === "asc" ? "desc" : "asc";
    this.setState({
      sortDir: sortDir
    });
    this.query({
      searchText: this.state.searchText,
      sortDir: sortDir
    });
  };

  // 20 ...16
  render() {
    let showMore=false;
    const { resultItems } = this.state;
    const i18n = Context.instance.i18n;
    const listCount = i18n.spaceplanner.backstage.openPlan.listCount;
    const countString = resultItems
      ? listCount.replace("{count}", resultItems.length)
      : null;
    
      if(resultItems){
        if(this.state.nextStart > 1) showMore=true;
      }

    //const project = Context.instance.spaceplanner.planner.project;
    //const isVersioned = (project && project.isVersioned);
    const showSearch = true;
    return (
      <ContentWrapper>
        <HeaderContainer>
          <Header>{i18n.spaceplanner.backstage.openPlan.caption}</Header>
          <SearchWrapper>
            {showSearch ? (
              <TextField
                autoFocus
                search
                placeholder={
                  i18n.spaceplanner.backstage.openPlan.searchPlaceholder
                }
                onChange={evt => this.onSearchTextChanged(evt)}
              />
            ) : null}
          </SearchWrapper>
        </HeaderContainer>
        <SubHeaderContainer>
          {countString}
          {this.renderSort()}
        </SubHeaderContainer>
        <TableContainer>
          <Table>
            <Thead>{this.renderItemsHeader()}</Thead>
            <Tbody>{this.renderItems()}</Tbody>
          </Table>
          {showMore && this.renderMore()}
        </TableContainer>
      </ContentWrapper>
    );
  }

  renderMore=()=> {
    const i18n = Context.instance.i18n;

    return (
      <ListItem key={"more"} moreButton>
        <Button disabled={this.state.isDisable}
        onClick={this.moreClicked}>{i18n.general.more}</Button>
      </ListItem>
    );
  }

  moreClicked=()=>{
    if (this.state.isWorking) return;
    this.setState({
      isWorking: true
    });
    this.queryHosted({
      isMore:true
    });
  }

  renderSort = () => {
    const i18n = Context.instance.i18n;
    let showModifiedDate;
    const project = Context.instance.spaceplanner.planner.project;
    if (project && project.isVersioned){
      showModifiedDate = (<MenuItem value="modified">
      {i18n.spaceplanner.backstage.openPlan.headers.modified}
      </MenuItem>)
    }else{
      showModifiedDate=(<></>)
    }
    const sortDir =
      this.state.sortDir === "asc" ? (
        <Button
          small
          iconButton
          title={i18n.workOrders.sort.ascendingSort} 
          onClick={() => this.changeSortDir()}
          icon={<SortAscendingIcon/>}></Button>
      ) : (
        <Button
          small
          iconButton
          title={i18n.workOrders.sort.descendingSort} 
          onClick={() => this.changeSortDir()}
          icon={<SortDescendingIcon />}>
        </Button>
      );
    return (
      <SortContainer>
        {sortDir}
        <Select
          minimal
          onChange={this.changeSortBy}
          selectedValue={this.state.sortBy}
          title={i18n.sort.fieldSortBy}
        >
          <MenuItem value="title">
            {i18n.spaceplanner.backstage.openPlan.headers.title}
          </MenuItem>
          <MenuItem value="owner">
            {i18n.spaceplanner.backstage.openPlan.headers.owner}
          </MenuItem>
          <MenuItem value="created">
            {i18n.spaceplanner.backstage.openPlan.headers.createdOn}
          </MenuItem>
          {showModifiedDate}
        </Select>
      </SortContainer>
    );
  };

  renderItemsHeader = () => {
    let showModifiedDate;
    const project = Context.instance.spaceplanner.planner.project;
    if (project && project.isVersioned) showModifiedDate=true;
    const i18n = Context.instance.i18n;
    return (
      <Tr>
        <Th>{i18n.spaceplanner.backstage.openPlan.headers.title}</Th>
        <Th>{i18n.spaceplanner.backstage.openPlan.headers.created}</Th>
        {showModifiedDate &&
          <Th>{i18n.spaceplanner.backstage.openPlan.headers.modified}</Th>}
        <Th></Th>
      </Tr>
    );
  };

  renderItems = () => {
    const i18n = Context.instance.i18n;
    const { resultItems } = this.state;
    return resultItems && resultItems.length > 0 ? (
      resultItems.map(item => this.renderItem(item))
    ) : (
      <Tr>
        <Td colspan="4">{i18n.portalItemBrowser.noMatch}</Td>
      </Tr>
    );
  };

  renderItem = item => {
    const i18n = Context.instance.i18n;
    let showModifiedDate;
    const project = Context.instance.spaceplanner.planner.project;
    if (project && project.isVersioned) showModifiedDate=true;
    const dateLabelString = i18n.spaceplanner.backstage.openPlan.dateLabel;
    const createdDateString = dateLabelString.replace("{date}", item.createdString);
    const modifiedDateString = item.modifiedString;
    const description =
      item.summary || i18n.spaceplanner.backstage.openPlan.noDescription;
    const disableDelete = this.disableDelete(item);
    return (
      <Tr key={item.id} onClick={evt => this.openPlan(evt, item)} listitem link>
        <Td>
          <div style={{ fontWeight: "bold" }}>{item.title}</div>
          <i>{description}</i>
        </Td>
        <Td>
          <div>{item.owner}</div>
          <div>{createdDateString}</div>
        </Td>
        {showModifiedDate && <Td>
          <div>{modifiedDateString}</div>
        </Td>}
        <Td>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button small onClick={evt => this.openPlan(evt, item)}>
              {i18n.spaceplanner.backstage.openPlan.openButton}
            </Button>
            <Button
              small
              iconButton
              onClick={evt => this.deletePlan(evt, item)}
              disabled={disableDelete}
              title={i18n.general.del}
              icon={<DeleteIcon />}
            ></Button>
          </div>
        </Td>
      </Tr>
    );
  };
}
